<ng-template #loading>
    <div class="m-loader m-loader--brand pb-5 text-center"></div>
</ng-template>

<form *ngIf="form; else loading" [formGroup]="form" novalidate>
    <div class="row m-row--no-padding">
        <div class="col-lg-3 d-flex">
            <i
                ngbTooltip="Izvajalec storitve"
                class="la la-stethoscope m--font-inverse-light mt-2 mr-2"
                i18n-ngbTooltip="@@53071fadc2548c8e8de41b3421d229d712e9a44f"
            ></i>

            <ng-select
                [items]="allSubcontractors"
                (change)="onSubConctractorChange($event)"
                bindLabel="name"
                tabindex="2"
                formControlName="selectedSubcontractor"
                class="w-100"
                [ngClass]="{ 'border-danger border': formControls['selectedSubcontractor'].errors }"
            >
                <ng-template ng-optgroup-tmp let-item="item">
                    {{ item.name }}
                </ng-template>
            </ng-select>
        </div>

        <div class="col-lg-3 d-flex">
            <i
                ngbTooltip="Nosilna storitev"
                class="la la-hand-paper-o m--font-inverse-light mt-2 mx-2"
                i18n-ngbTooltip="@@62d6803396ae2c32c9b7855af7812186913ca0f7"
            ></i>
            <ng-select
                [items]="servicesForSubconstractor"
                [compareWith]="equalsAnyById"
                (change)="onServiceChange()"
                bindLabel="name"
                tabindex="3"
                groupBy="type"
                formControlName="selectedService"
                class="w-100"
                [ngClass]="{ 'border-danger border': formControls['selectedService'].errors }"
            >
                <ng-template ng-optgroup-tmp let-item="item">
                    {{ item.type | serviceTypePipe }}
                </ng-template>
            </ng-select>
        </div>

        <div class="col-lg-3 d-flex">
            <i ngbTooltip="Prostor izvedbe" class="la la-sign-in m--font-inverse-light mt-2 mx-2"></i>
            <select
                [compareWith]="equalsAnyById"
                tabindex="4"
                formControlName="selectedAsset"
                class="form-control m-input"
                [ngClass]="{ 'border-danger border': formControls['selectedAsset'].errors }"
            >
                <option></option>
                <optgroup *ngFor="let group of assetGroups" label="{{ group.label }}">
                    <option *ngFor="let asset of group.data" [ngValue]="asset">
                        {{ asset.name }}
                    </option>
                </optgroup>
            </select>
        </div>

        <div class="col-lg-3 d-flex">
            <i
                ngbTooltip="Posebna oznaka"
                class="la la-star mt-2 mx-2"
                [ngClass]="formControls['customTagId']?.value?.classColor || 'mf-custom-tag'"
                i18n-ngbTooltip="@@3cd2ad7b8e6ba51d2ebb3fadbbabe78f42525c9a"
            ></i>
            <select [compareWith]="equalsAnyById" formControlName="customTagId" class="form-control m-input">
                <option *ngFor="let tag of customTags" [ngValue]="tag">
                    {{ tag.name }}
                </option>
            </select>
        </div>
    </div>
    <div class="row m-row--no-padding mt-2">
        <div class="col-lg-3 d-flex">
            <i ngbTooltip="Datum termina" class="la la-calendar m--font-inverse-light mt-2 mr-2"></i>
            <input
                [options]="calendarOptions"
                (selected)="setDate($event)"
                type="text"
                name="daterangeInput"
                daterangepicker
                autocomplete="off"
                formControlName="selectedDateView"
                class="form-control m-input"
                [ngClass]="{ 'border-danger border': formControls['selectedDateView'].errors }"
            />
        </div>

        <div class="col-lg-3 d-flex">
            <i ngbTooltip="Ura pričeteka termina" class="la la-clock-o m--font-inverse-light mt-2 mx-2"></i>
            <input
                [textMask]="{ mask: timeInputMask, keepCharPositions: true }"
                (change)="onServiceChange()"
                type="text"
                placeholder="hh:mm"
                formControlName="selectedTime"
                class="form-control m-input"
                [ngClass]="{ 'border-danger border': formControls['selectedTime'].errors }"
            />
        </div>

        <div class="col-lg-3 d-flex">
            <i ngbTooltip="Ura konca termina" class="la la-step-forward m--font-inverse-light mt-2 mx-2"></i>
            <input
                [textMask]="{ mask: timeInputMask, keepCharPositions: true }"
                type="text"
                placeholder="hh:mm"
                formControlName="selectedTimeEnd"
                class="form-control m-input"
                [ngClass]="{ 'border-danger border': formControls['selectedTimeEnd'].errors }"
            />
        </div>
        <div class="col-lg-3 d-flex">
            <i ngbTooltip="Tip termina" class="la la-calendar-check-o m--font-inverse-light mt-2 mx-2"></i>
            <select [compareWith]="equalsAnyById" formControlName="termType" class="form-control m-input">
                <option *ngFor="let type of termType?.table" [ngValue]="type">
                    {{ type?.name }}
                </option>
            </select>
        </div>
    </div>
</form>
